import { useState, useEffect, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { toPng, toJpeg } from "html-to-image";
import { useSnackbar } from "notistack";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import "./developingIdentity.css";
import IsLoading from "../../isLoading";
import GNFront from "./id_cards_images/mconsStdFrnt.png";
import MDFront from "./id_cards_images/mconsStdFrntMid.png";
import IDBack from "./id_cards_images/mconsStdBack.png";

// import from MUI
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import SearchIcon from "@mui/icons-material/Search";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import TocOutlinedIcon from "@mui/icons-material/TocOutlined";

import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

let dataFetch;

export default function DevelopingIdentity() {
  const [loading, setLoading] = useState(false);
  const [changeview, setChangeView] = useState("");
  const [getPrintReady, setGetPrintReady] = useState(false);
  const [appNo, setAppNo] = useState("");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState([]);
  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim() === "") {
      setFiltered([]);
    } else {
      const filtered = dataFetch.filter(
        (student) =>
          student.idCard?.status?.toLowerCase().includes(term) ||
          student.academicInfo?.admission_number
            ?.toLowerCase()
            .includes(term) ||
          student.admission_number
            ?.toLowerCase()
            .includes(term.toLowerCase()) ||
          student.personalInfo?.first_Name?.toLowerCase().includes(term),
      );
      setFiltered(filtered);
    }
  };

  async function getApplicants() {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/developer_hub/get_students_identity`,
      )
      .then((response) => {
        dataFetch = response.data.data;
        if (response?.data.status === 200) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        } else if (response?.data.status === 400) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "warning",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }
        console.log(response);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  useEffect(() => {
    getApplicants();
  }, []);

  return (
    <>
      {loading ? (
        <IsLoading />
      ) : (
        <div className=" students_data">
          {!getPrintReady && (
            <div className="fx-cl">
              <header className="fx-ac fx-jb space4">
                <div className="adminSearchCont">
                  <span style={{ fontSize: "1.2rem" }}>
                    Search admission number
                  </span>

                  <div className="adminSearch fx-jb">
                    <input
                      type="text"
                      name="idCard"
                      placeholder="im looking for..."
                      value={searchTerm}
                      onChange={handleSearch}
                    />
                    <button
                      onClick={() => alert("no function running currently")}
                    >
                      <SearchIcon fontSize="large" />
                    </button>
                  </div>
                </div>

                <div className="fx-ac space2">
                  <span onClick={() => setChangeView("table")}>
                    <TocOutlinedIcon />
                  </span>
                  <span onClick={() => setChangeView("grid")}>
                    <AppsOutlinedIcon />
                  </span>
                </div>
              </header>
            </div>
          )}
          <IDCARDS
            dataFetch={dataFetch}
            handleSearch={handleSearch}
            searchTerm={searchTerm}
            filtered={filtered}
            getPrintReady={getPrintReady}
            setGetPrintReady={setGetPrintReady}
          />
        </div>
      )}
    </>
  );
}

function IDCARDS({
  searchTerm,
  filtered,
  dataFetch,
  getPrintReady,
  setGetPrintReady,
}) {
  const { enqueueSnackbar } = useSnackbar();

  const [searchParams, setSearchParams] = useSearchParams();

  const PAGE_SIZE = 4;

  const currentPage = Number(searchParams.get("page")) || 1;

  const activeData =
    filtered.length > 0 || searchTerm.trim() !== "" ? filtered : dataFetch;

  const totalPages = Math.ceil((activeData?.length || 0) / PAGE_SIZE);

  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const endIndex = startIndex + PAGE_SIZE;

  const paginatedData = activeData?.slice(startIndex, endIndex);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setSearchParams({ page: currentPage + 1 });
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setSearchParams({ page: currentPage - 1 });
    }
  };

  function switchIDCrdView() {
    if (
      searchTerm.trim() !== "" &&
      (!paginatedData || paginatedData.length === 0)
    ) {
      return <p className="no--found">No Identification Card found</p>;
    }

    return (
      <div
        className="A4Display g g4"
        onClick={() => setGetPrintReady(!getPrintReady)}
      >
        {paginatedData?.map((response, index) => {
          const nameLength =
            (response?.personalInfo?.first_Name?.toLowerCase() || "") +
            " " +
            (response?.personalInfo?.sur_Name?.toLowerCase() || "") +
            " " +
            (response?.personalInfo?.other_Name?.toLowerCase() || "");
          return (
            <figure
              className="stdIDCont fx-cl space2"
              key={response._id || index}
            >
              <div
                className={`${
                  response?.academicInfo?.course_of_study === "General Nursing"
                    ? "stdIDFront"
                    : "stdIDFrontMid"
                } fx-cl fx-ac fx-jc spacem`}
              >
                {response?.academicInfo?.course_of_study ===
                "General Nursing" ? (
                  <img src={GNFront} alt="Passport" />
                ) : (
                  <img src={MDFront} alt="Passport" />
                )}

                <div className="fx-cl fx-ac fx-jc space3">
                  <figure className="idCrdPassport fx-ac fx-jc">
                    {response.personalInfo?.passport ? (
                      <img src={response.personalInfo?.passport} alt="" />
                    ) : (
                      "No PassPort"
                    )}
                  </figure>

                  <div className="idCrdDiscr fx-cl">
                    <h2
                      style={{
                        fontSize: nameLength.length > 14 && "1.9rem",
                      }}
                    >
                      {`${response?.personalInfo?.first_Name?.toLowerCase() || ""} ${
                        response?.personalInfo?.sur_Name?.toLowerCase() || ""
                      } ${
                        response?.personalInfo?.other_Name?.toLowerCase() || ""
                      }`}
                    </h2>

                    <span>
                      {response?.admission_number ||
                        response?.academicInfo?.admission_number}
                    </span>
                  </div>

                  <figure className="idCrdSign">
                    {response.personalInfo?.signature ? (
                      <img
                        src={response.personalInfo.signature}
                        alt="signature"
                      />
                    ) : (
                      ""
                    )}
                  </figure>
                </div>
              </div>

              <div className="stdIDBack fx-cl fx-ac fx-jc spacem">
                <img src={IDBack} alt="ID Back" />
                <figure className="idCrdQR fx-ac fx-jc">
                  <QRCodeCanvas
                    value={JSON.stringify({
                      passport: response?.personalInfo?.passport || "",
                      admission_number:
                        response?.admission_number ||
                        response?.academicInfo?.admission_number ||
                        "",
                      first_Name: response?.personalInfo?.first_Name || "",
                      sur_Name: response?.personalInfo?.sur_Name || "",
                      other_Name: response?.personalInfo?.other_Name || "",
                      department: response?.academicInfo?.department || "",
                      programme: response?.academicInfo?.programme || "",
                      email: response?.contactInfo?.email || "",
                      phone_number: response?.contactInfo?.phone_number || "",
                    })}
                    size={77}
                    style={{ margin: "1rem" }}
                  />
                </figure>
              </div>
            </figure>
          );
        })}
      </div>
    );
  }

  // FUNCTIONS FOR EXPORTING IDENTITY TO PGN AND JPEG

  const componentRef = useRef(null);

  const downloadImage = async (type = "png") => {
    const node = componentRef.current;

    if (!node) return;

    try {
      let dataUrl;

      if (type === "jpeg") {
        dataUrl = await toJpeg(node, {
          quality: 0.95,
          backgroundColor: "#ffffff",
        });
      } else {
        dataUrl = await toPng(node, {
          backgroundColor: "#ffffff",
        });
      }

      const link = document.createElement("a");
      link.download = `student_identity.${type}`;
      link.href = dataUrl;
      link.click();
    } catch (error) {
      console.error("Image export failed:", error);
    }
  };

  return (
    <div className="stdIDGenCont fx-cl space2 fx-ac fx-jc">
      {!getPrintReady && (
        <div className="IdentActionBtns fx-ac fx-jc space1">
          <button
            onClick={() => downloadImage("png")}
            style={{
              backgroundColor: "#6693fa",
              color: "#fff",
            }}
          >
            PNG
            <RemoveRedEyeOutlinedIcon />
          </button>

          <button
            onClick={() => downloadImage("jpeg")}
            style={{
              backgroundColor: "#f35e6a",
              color: "#fff",
            }}
          >
            JPG
            <PrivacyTipOutlinedIcon />
          </button>

          <button
            onClick={() => setGetPrintReady(true)}
            style={{
              backgroundColor: "#00d285",
              color: "#fff",
              width: "12rem",
            }}
          >
            Action
          </button>
        </div>
      )}

      <div className="fx space1 fx-ac" ref={componentRef}>
        {switchIDCrdView()}
      </div>

      {!getPrintReady && (
        <>
          {totalPages > 1 && (
            <div
              className="fx-cl fx-ac fx-jc space2"
              style={{ marginTop: "2rem" }}
            >
              <div className="identControlButn fx-ac fx-jc space2">
                <button onClick={prevPage} disabled={currentPage === 1}>
                  Previous
                </button>

                <span>
                  Page {currentPage} of {totalPages}
                </span>

                <button
                  onClick={nextPage}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>

              <div className="IdentPaginatBtns fx-ac fx-jc space1">
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() =>
                      setSearchParams({
                        page: index + 1,
                      })
                    }
                    style={{
                      background:
                        currentPage === index + 1 ? "#6693fa" : "#eee",
                      color: currentPage === index + 1 ? "#fff" : "#000",
                    }}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

// function IDCARDS({ searchTerm, filtered, dataFetch }) {
//   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

//   function switchIDCrdView() {
//     if (filtered.length > 0) {
//       return (
//         <div className="A4Display g g4">
//           {filtered?.map((response, index) => {
//             return (
//               <figure className="stdIDCont fx-cl space2">
//                 <div
//                   className={`${response?.academicInfo?.course_of_study == "General Nursing" ? "stdIDFront" : "stdIDFrontMid"}  fx-cl fx-ac fx-jc spacem`}
//                 >
//                   <div className="fx-cl fx-ac fx-jc space3">
//                     <figure
//                       className="idCrdPassport fx-ac fx-jc"
//                       style={{
//                         backgroundImage: response.personalInfo?.passport
//                           ? `url(${response.personalInfo.passport})`
//                           : "none",
//                       }}
//                     >
//                       {response.personalInfo?.passport ? " " : "No PassPort"}
//                     </figure>

//                     <div className="idCrdDiscr fx-cl ">
//                       <h2>
//                         {response?.personalInfo.first_Name.toLowerCase() +
//                           " " +
//                           response?.personalInfo.sur_Name.toLowerCase() +
//                           " " +
//                           response?.personalInfo.other_Name.toLowerCase()}
//                       </h2>
//                       <span>
//                         {" "}
//                         {response.admission_number ||
//                           response?.academicInfo?.admission_number}
//                       </span>

//                       {/* <span>Department:{response.academicInfo?.department}</span>
//                     <span>Programme: {response.academicInfo?.programme}</span> */}
//                     </div>
//                     <figure className="idCrdSign">
//                       {response.personalInfo?.signature ? (
//                         <img src={response.personalInfo?.signature} alt="gal" />
//                       ) : (
//                         "No signature on this Account"
//                       )}
//                     </figure>
//                   </div>
//                 </div>
//                 <div className="stdIDBack  fx-cl fx-ac fx-jc spacem">
//                   {dataFetch && (
//                     <figure className="idCrdQR fx-ac fx-jc ">
//                       <QRCodeCanvas
//                         value={JSON.stringify({
//                           passport: response?.personalInfo?.passport || "",
//                           admission_number:
//                             response?.admission_number ||
//                             response?.academicInfo?.admission_number ||
//                             "",
//                           first_Name: response?.personalInfo?.first_Name || "",
//                           sur_Name: response?.personalInfo?.sur_Name || "",
//                           other_Name: response?.personalInfo?.other_Name || "",
//                           department: response?.academicInfo?.department || "",
//                           programme: response?.academicInfo?.programme || "",
//                           email: response?.contactInfo?.email || "",
//                           phone_number:
//                             response?.contactInfo?.phone_number || "",
//                         })}
//                         size={77}
//                         style={{ margin: "1rem" }}
//                       />
//                     </figure>
//                   )}
//                 </div>
//               </figure>
//             );
//           })}
//         </div>
//       );
//     } else if (searchTerm.trim() !== "") {
//       return <p className="no--found">No Identification Card found</p>;
//     } else {
//       return (
//         <div className="A4Display g g4">
//           {dataFetch?.map((response, index) => {
//             return (
//               <figure className="stdIDCont fx-cl space1" key={index}>
//                 <div
//                   className={`${response?.academicInfo?.course_of_study == "General Nursing" ? "stdIDFront" : "stdIDFrontMid"}  fx-cl fx-ac fx-jc spacem`}
//                 >
//                   <div className="fx-cl fx-ac fx-jc space3">
//                     <figure
//                       className="idCrdPassport fx-ac fx-jc"
//                       // style={{
//                       //   backgroundImage:
//                       //     response?.personalInfo?.passport || response?.passport
//                       //       ? `url(${response.personalInfo?.passport || response.passport})`
//                       //       : "none",
//                       // }}
//                     >
//                       {response.personalInfo?.passport ? (
//                         <img
//                           src={
//                             response.personalInfo?.passport ||
//                             response.personalInfo.passport
//                           }
//                           alt=""
//                         />
//                       ) : (
//                         "No PassPort"
//                       )}
//                     </figure>

//                     <div className="idCrdDiscr fx-cl">
//                       <h2>
//                         {response?.personalInfo.first_Name.toLowerCase() +
//                           " " +
//                           response?.personalInfo.sur_Name.toLowerCase() +
//                           " " +
//                           response?.personalInfo.other_Name.toLowerCase()}
//                       </h2>
//                       <span>
//                         {" "}
//                         {response.admission_number ||
//                           response?.academicInfo?.admission_number}
//                       </span>

//                       {/* <span>Department:{response.academicInfo?.department}</span>
//                     <span>Programme: {response.academicInfo?.programme}</span> */}
//                     </div>
//                     <figure className="idCrdSign">
//                       {response.personalInfo?.signature ? (
//                         <img src={response.personalInfo?.signature} alt="gal" />
//                       ) : (
//                         "No signature on this Account"
//                       )}
//                     </figure>
//                   </div>
//                 </div>
//                 <div className="stdIDBack  fx-cl fx-ac fx-jc spacem">
//                   {dataFetch && (
//                     <figure className="idCrdQR fx-ac fx-jc ">
//                       <QRCodeCanvas
//                         value={JSON.stringify({
//                           passport: response?.personalInfo?.passport || "",
//                           admission_number:
//                             response?.admission_number ||
//                             response?.academicInfo?.admission_number ||
//                             "",
//                           first_Name: response?.personalInfo?.first_Name || "",
//                           sur_Name: response?.personalInfo?.sur_Name || "",
//                           other_Name: response?.personalInfo?.other_Name || "",
//                           department: response?.academicInfo?.department || "",
//                           programme: response?.academicInfo?.programme || "",
//                           email: response?.contactInfo?.email || "",
//                           phone_number:
//                             response?.contactInfo?.phone_number || "",
//                         })}
//                         size={77}
//                         style={{ margin: "1rem" }}
//                       />
//                     </figure>
//                   )}
//                 </div>
//               </figure>
//             );
//           })}
//         </div>
//       );
//     }
//   }

//   const qrPayload = JSON.stringify({
//     admission_number:
//       dataFetch?.admission_number ||
//       dataFetch?.academicInfo?.admission_number ||
//       "",
//     first_Name: dataFetch?.personalInfo?.first_Name || "",
//     sur_Name: dataFetch?.personalInfo?.sur_Name || "",
//     other_Name: dataFetch?.personalInfo?.other_Name || "",
//     department: dataFetch?.academicInfo?.department || "",
//     programme: dataFetch?.academicInfo?.programme || "",
//     email: dataFetch?.contactInfo?.email || "",
//     phone_number: dataFetch?.contactInfo?.phone_number || "",
//   });

//   return (
//     <div className="stdIDGenCont fx-cl space2 fx-ac fx-jc">
//       <div className="fx-ac fx-jc space1">
//         <button
//           style={{
//             backgroundColor: "#6693fa",
//             color: "#fff",
//           }}
//         >
//           <RemoveRedEyeOutlinedIcon />
//         </button>
//         <button
//           style={{
//             backgroundColor: "#f35e6a",
//             color: "#fff",
//           }}
//         >
//           <PrivacyTipOutlinedIcon />
//         </button>
//         <button
//           style={{
//             backgroundColor: "#00d285",
//             color: "#fff",
//             width: "12rem",
//           }}
//         >
//           Action
//         </button>
//       </div>
//       <div className="fx space1 fx-ac">{switchIDCrdView()}</div>
//     </div>
//   );
// }

function StudentsIdentity() {
  const componentRef = useRef(null);

  const downloadImage = async (type = "png") => {
    const node = componentRef.current;

    if (!node) return;

    try {
      let dataUrl;

      if (type === "jpeg") {
        dataUrl = await toJpeg(node, {
          quality: 0.95,
          backgroundColor: "#ffffff",
        });
      } else {
        dataUrl = await toPng(node, {
          backgroundColor: "#ffffff",
        });
      }

      const link = document.createElement("a");
      link.download = `student_identity.${type}`;
      link.href = dataUrl;
      link.click();
    } catch (error) {
      console.error("Image export failed:", error);
    }
  };

  return (
    <div>
      <div className="fx-ac space3">
        <button onClick={() => downloadImage("png")}>Download as PNG</button>

        <button onClick={() => downloadImage("jpeg")}>Download as JPG</button>
      </div>

      {/* Component to capture */}
      <div ref={componentRef} style={{ width: "8.5rem" }}></div>
    </div>
  );
}
